const REQUEST_STATUS_LABELS = {
  active: "Activa",
  in_process: "En Proceso",
  resolved: "Resuelta",
  closed: "Cerrada",
};

const REQUEST_STATUS_BADGE_CLASSES = {
  active: "bg-green-100 text-green-700",
  in_process: "bg-blue-100 text-blue-700",
  resolved: "bg-purple-100 text-purple-700",
  closed: "bg-gray-100 text-gray-700",
};

export const getPropertyRequestStatusLabel = (status) =>
  REQUEST_STATUS_LABELS[status] || "Cerrada";

export const getPropertyRequestStatusBadgeClass = (status) =>
  REQUEST_STATUS_BADGE_CLASSES[status] || REQUEST_STATUS_BADGE_CLASSES.closed;
